import { captureModuleRegistry } from '../../modules/capture/registry';
import { useAppStore } from '../../app/store/useAppStore';
import { Icon } from '../ui/Icon';
import { Modal } from '../ui/Modal';

export function ModuleSelector() {
  const activeId = useAppStore((state) => state.activeCaptureModuleId);
  const close = useAppStore((state) => state.closeOverlay);
  return <Modal title="拍照模組" kicker="MODULE PACK" onClose={close}>
    <div className="module-list">{Object.values(captureModuleRegistry).map((module) => <button className={`module-option ${module.id === activeId ? 'selected' : ''}`} key={module.id} type="button" onClick={close}>
      <span className="module-mark"><Icon name="module" /></span><span><strong>{module.name}</strong><small>{module.description}</small><em>{module.id} / v{module.version}</em></span><Icon name="check" />
    </button>)}</div>
    <p className="coming-soon">更多模組即將加入</p>
    <p className="privacy-note">拍照模組只改變拍攝體驗；相機、GPS、相簿與保存核心保持共用。</p>
  </Modal>;
}
